/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/no-danger */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import { Space } from 'antd';
import { useDispatch } from 'react-redux';
import { fetchUserNameById } from '../../redux/userSlice';
import { getFleetOperatorNameById } from '../../redux/fleetOperatorSlice';
import ImageComponent from '../Global/ImageComponent/ImageComponent';
import { formatChangeValue } from '../../Utils/Constants/utils';

const IMAGE_FIELD_REGEX = /(photo|picture|image|avatar|thumbnail|profilePicture)/i;
const IS_REVIEWED_BY_REGEX = /(?:applicationReviewedBy|reviewedUser)/i;

const isImageField = (field) => IMAGE_FIELD_REGEX.test(field);
const isReviewedBy = (field) => IS_REVIEWED_BY_REGEX.test(field);

const isObjectValue = (value) =>
	value !== null && typeof value === 'object' && !Array.isArray(value);

const getUniqueObjectValues = (items = []) => {
	return [
		...new Map(
			items
				.map((item) => {
					if (!item || typeof item !== 'object') {
						return null;
					}

					const objectValue = Object.values(item).find(
						(itemValue) =>
							itemValue !== null && itemValue !== undefined && itemValue !== '',
					);

					return typeof objectValue === 'string' ? objectValue.trim() : objectValue;
				})
				.filter(Boolean)
				.map((itemValue) => [String(itemValue).toLowerCase(), itemValue]),
		).values(),
	];
};

const AuditChangeValue = ({ field, value, old }) => {
	const [reviewedByName, setReviewedByName] = useState('');
	const [reviewedByLoading, setReviewedByLoading] = useState(false);

	const [fleetOperatorNames, setFleetOperatorNames] = useState([]);
	const [fleetOperatorLoading, setFleetOperatorLoading] = useState(false);

	const dispatch = useDispatch();

	const isImage = isImageField(field);
	const isReviewedByField = isReviewedBy(field);

	useEffect(() => {
		if (!isReviewedByField || !Number.isFinite(value)) {
			return;
		}

		const fetchReviewer = async () => {
			try {
				setReviewedByLoading(true);

				const reviewer = await dispatch(fetchUserNameById(value)).unwrap();

				setReviewedByName(reviewer);
			} finally {
				setReviewedByLoading(false);
			}
		};

		fetchReviewer();
	}, [dispatch, isReviewedByField, value]);

	useEffect(() => {
		if (!field.includes('fleetOperator') || !Array.isArray(value) || value.length === 0) {
			setFleetOperatorNames([]);
			return;
		}

		const fetchFleetOperators = async () => {
			try {
				setFleetOperatorLoading(true);

				const results = await Promise.allSettled(
					value.map((id) => dispatch(getFleetOperatorNameById(id)).unwrap()),
				);

				const operators = results.map((result, index) => {
					if (result.status === 'fulfilled') {
						return {
							id: value[index],
							name: result.value,
						};
					}

					return {
						id: value[index],
						name: `Unknown user (${value[index]})`,
					};
				});

				setFleetOperatorNames(operators);
			} finally {
				setFleetOperatorLoading(false);
			}
		};

		fetchFleetOperators();
	}, [dispatch, field, value]);

	if (isImage) {
		if (!value || value === 0) {
			return <span style={{ color: '#8c8c8c' }}>No photo</span>;
		}

		return <ImageComponent size={80} imageId={value} />;
	}

	if (field.includes('fleetOperator')) {
		if (isObjectValue(value)) {
			return <div>{formatChangeValue(value.name)}</div>;
		}

		if (fleetOperatorLoading) {
			return <>Loading...</>;
		}

		if (!Array.isArray(value) || value.length === 0) {
			return <span style={{ color: '#8c8c8c' }}>No fleet operators</span>;
		}

		return (
			<Space direction='vertical' size={0}>
				{fleetOperatorNames.map((operator) => (
					<div key={operator.id}>- {operator.name}</div>
				))}
			</Space>
		);
	}

	if (isReviewedByField) {
		if (reviewedByLoading) {
			return <>Loading...</>;
		}

		return <div>{reviewedByName || formatChangeValue(value)}</div>;
	}

	if (isObjectValue(value)) {
		const objectValues = Object.values(value).filter(
			(item) => item !== null && item !== undefined && item !== '',
		);

		if (objectValues.length === 0) {
			return <span style={{ color: '#8c8c8c' }}>None</span>;
		}

		if (objectValues.length === 1) {
			return <div>{formatChangeValue(objectValues[0])}</div>;
		}

		return (
			<div
				style={{
					display: 'flex',
					flexDirection: 'column',
					gap: 4,
				}}>
				{objectValues.map((item, index) => (
					<div
						// eslint-disable-next-line react/no-array-index-key
						key={index}>
						{formatChangeValue(item)}
					</div>
				))}
			</div>
		);
	}

	if (Array.isArray(value) && value.every((item) => item && typeof item === 'object')) {
		const values = getUniqueObjectValues(value);

		if (values.length === 0) {
			return <span style={{ color: '#8c8c8c' }}>None</span>;
		}

		return (
			<div
				style={{
					display: 'flex',
					flexWrap: 'wrap',
					gap: 4,
				}}>
				{values.map((item, index) => (
					<span
						// eslint-disable-next-line react/no-array-index-key
						key={index}
						style={{
							display: 'inline-flex',
							alignItems: 'center',
							padding: '5px 10px',
							borderRadius: 6,
							background: old ? '#fff1f0' : '#f6ffed',
							border: `1px solid ${old ? '#ffa39e' : '#b7eb8f'}`,
							color: old ? '#cf1322' : '#389e0d',
							fontSize: 13,
							fontWeight: 500,
							lineHeight: '18px',
						}}>
						{item}
					</span>
				))}
			</div>
		);
	}

	return <>{formatChangeValue(value)}</>;
};

export default AuditChangeValue;
